<div>
    <iframe #iframe [src]="getUrl()" frameborder="0"></iframe>
</div>